import { combineReducers } from 'redux';

import pricingContentReducer from './pricingContentReducer';
import pricingMetaReducer from './pricingMetaReducer';
import pricingSubscriptionDataReducer from './pricingSubscriptionDataReducer';
import saleReducer from './saleReducer';

export default combineReducers({
  sale: saleReducer,
  meta: pricingMetaReducer,
  content: pricingContentReducer,
  pricingSubscriptionData: pricingSubscriptionDataReducer
});
